<app-online-users (sendData)="openModal($event)"></app-online-users>
<app-admin-header [header]="header" [links]="links" [breadcrumbs]="breadcrumbs" [stats]="stats"></app-admin-header>

<div class="d-flex ioioio">
  <p-tabMenu class="w-100 justify-content-center ioioio" [model]="menuitems" [(activeItem)]="activeItem"></p-tabMenu>
</div>

<div class="container-fluid v4-bg-img">
  <div [hidden]="skelition" class="container max-width-tabb">
    <p-messages [(value)]="messages" [enableService]="false"></p-messages>
    <div class="row">
      <div class="col ppp-dropdown">
        <p-treeSelect filterButton appendTo="body" class="w-md-20rem w-100" containerStyleClass="w-100"
          [(ngModel)]="filters.ou" [options]="ouOptions"
          placeholder="{{ 'Choose an organizational unit' | translator }}" [filter]="true" [filterInputAutoFocus]="true"
          (onNodeSelect)="filters.ou = $event.node;handleFilter();">
        </p-treeSelect>
      </div>
      <div class="col ppp-dropdown">
        <p-dropdown id="gender" filterButton [options]="genderOptions" [(ngModel)]="filters.gender"
          (ngModelChange)="handleFilter()" placeholder="{{ 'Choose gender' | translator }}"
          styleClass="sstarabic w-100">
          <ng-template let-item pTemplate="item">
            <i [ngClass]="item.icon"></i>
            {{ item.label }}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="col ppp-dropdown">
        <p-dropdown id="manager" filterButton [(ngModel)]="filters.manager" (ngModelChange)="handleFilter()"
          [options]="managerOptions" [placeholder]="'Manager' | translator" styleClass="sstarabic w-100">
          <ng-template let-item pTemplate="item">
            <i [ngClass]="item.icon"></i>
            {{ item.label }}
          </ng-template>
        </p-dropdown>
      </div>

      <div class="col ppp-dropdown">
        <p-dropdown id="location" filterButton [(ngModel)]="filters.location" (ngModelChange)="handleFilter()"
          [options]="locationOptions" [placeholder]="'Select city' | translator" styleClass="sstarabic w-100">
          <ng-template let-item pTemplate="item">
            <i [ngClass]="item.icon"></i>
            {{ item.label }}
          </ng-template>
        </p-dropdown>
      </div>
      <div class="col-12 d-flex align-items-center justify-content-start">
        <p-button [label]="'Reset' | translator" (onClick)="resetFilter()"></p-button>
      </div>
    </div>
    <app-no-data *ngIf="data.length <= 0 && !skelition"></app-no-data>
    <div *ngIf="data.length > 0">
      <app-table [unit]="'USER_MANAGEMENT'" [data]="data" (actionCall)="actionCall($event)"></app-table>
    </div>
  </div>
</div>

<!-- skelition   -->
<app-skelitions [hidden]="!skelition" [value]="2" class="mb-2"></app-skelitions>

<!-- Confirm Modal -->
<p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>

<!-- Edit User Modal -->
<p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Update user data' | translator }}"
  [(visible)]="editDialog" [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '1400px' }" [maximizable]="true">
  <app-signup-form (updatedData)="handleUpdatedUserData($event)" *ngIf="editDialog" [type]="'UPDATE'"
    [data]="editData"></app-signup-form>
</p-dialog>

<!-- Edit User Modal -->
<div class="card flex justify-content-center">
  <p-dialog [blockScroll]="true" [draggable]="false" header="{{ 'Disable account' | translator }}"
    [(visible)]="DeactivateDialog" [style]="{ margin: '0rem 1rem' }" [maximizable]="true">
    <div class="w-100">
      <p>{{ "the reason" | translator }}</p>
      <p-editor [(ngModel)]="deactivateData.reason" [style]="{ height: '320px' }">
      </p-editor>
      <p *ngIf="reasonError" style="color: red">{{ reasonError }}</p>
    </div>
    <ng-template pTemplate="footer">
      <button class="admin-btn" (click)="deactivateInit()">
        <i class="fa fa-check ml-2"></i>{{ "OK" | translator }}
      </button>
    </ng-template>
  </p-dialog>
</div>

<app-user-detail-model *ngIf="userHolder" (sendData)="userHolder = undefined"
  [user]="userHolder"></app-user-detail-model>

<app-footer></app-footer>